module.exports = __webpack_public_path__ + "img/921_part1_background_image1.70fead64.jpg";